export const getUUID = (): string => {
    try {
      // Only import if environment allows
      const { v4 } = require('uuid');
      return v4();
    } catch {
      return 'mocked-uuid';
    }
  };
  